

































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import Ajax from "../../lib/ajax";
import Language from "../../store/entities/system/language";
@Component({
    components: {}
})
export default class EditLanguage extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    @Prop({ type: Number }) editId;
    editOutput = {
        language: new Language()
    };
    language: Language = new Language();
    async save() {
        (this.$refs.languageForm as any).validate(async (valid: boolean) => {
            if (valid) {
                await Ajax.post('/api/services/app/Language/CreateOrUpdateLanguage',this.editOutput);

                (this.$refs.languageForm as any).resetFields();
                this.$emit("save-success");
                this.$emit("input", false);
            }
        });
    }
    cancel() {
        (this.$refs.languageForm as any).resetFields();
        this.$emit("input", false);
    }
    async visibleChange(value: boolean) {
        if (!value) {
            this.$emit("input", value);
        } else {
            let reponse = await Ajax.get('/api/services/app/Language/GetLanguageForEdit',{params:{id: this.editId}});
            this.editOutput = reponse.data.result;
        }
    }
    languageRule = {
        name: [
            {
                required: true,
                message: this.L("FieldIsRequired", undefined, this.L("Language")),
                trigger: "blur"
            }
        ],
        icon: [
            {
                required: true,
                message: this.L("FieldIsRequired", undefined, this.L("LanguageIcon")),
                trigger: "blur"
            }
        ]
    };
}
